import { render, staticRenderFns } from "./MoneyCell.vue?vue&type=template&id=4d4a1535&scoped=true&"
import script from "./MoneyCell.vue?vue&type=script&lang=ts&"
export * from "./MoneyCell.vue?vue&type=script&lang=ts&"
import style0 from "./MoneyCell.vue?vue&type=style&index=0&id=4d4a1535&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4a1535",
  null
  
)

export default component.exports